import styled from "@emotion/styled";

export const BuildDropdownContainer = styled.div`
  display: flex;
  width: 254px;
  height: 200px;
  flex-direction: column;
  position: absolute;
  z-index: 1000;

  background-color: white;
  border-radius: 0px 0px 8px 8px;
  box-shadow: var(--alias-style-shadow-strong);
  border: none;
`;

export const TextFilterContainer = styled.div`
  display: flex;
  padding: 6px;
  background-color: white;
  width: 100%;
  box-sizing: border-box;
`;

export const DropdownContainer = styled.div`
  display: flex;

  max-height: 180px;
  height: 100%;
  box-sizing: border-box;
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100%;

  flex-direction: column;
  border-radius: 0px 0px 8px 8px;
  background: var(--alias-color-background-normal-normal);

  box-shadow: var(--aliais-style-shadow-strong);
`;

export const AddItemContainer = styled.button`
  position: relative;
  display: flex;
  padding: 8px 12px;
  align-items: center;
  justify-content: start;
  gap: 4px;
  background-color: white;
  border: none;

  &:hover {
    background-color: var(--component-color-fill-normal);
  }
  cursor: pointer;
`;

export const ItemContainer = styled.button`
  position: relative;
  display: flex;
  padding: 8px 12px;
  align-items: center;
  gap: 4px;
  background-color: white;
  border: none;

  &:hover {
    background-color: var(--component-color-fill-normal);
  }
  cursor: pointer;

  .menu-icon {
    margin-left: auto;
  }
`;
